import { Loader } from 'components/Loader';
import { Paragraph } from 'components/Typography';
import { withInsuranceMachineStateV4 } from 'domains/signupv4/Insurance/context';
import { withScheduleMachineStateV4 } from 'domains/signupv4/schedule/context';
import { withSignupMachineStateV4 } from 'domains/signupv4/Wrapper/context';
import { useTranslation } from 'react-i18next';

const Loading: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="h-full flex flex-col justify-center items-center">
      <Loader
        iconClassName="w-40 h-40 text-primary-500"
        className="m-16
      "
      />
      <Paragraph className="text-center">{t('signup.direct.steps.loading')}</Paragraph>
    </div>
  );
};

export const SignupV4LoadingStep = withSignupMachineStateV4(Loading, ['loadingLeadData', 'upsertingInsuranceLead']);

export const ScheduleV4LoadingStep = withScheduleMachineStateV4(Loading, [
  'loadingAvailableConsultDates',
  'loadingEvaluationPrice',
  'loadingEvaluationPriceFailed',
  'loadingStripeAccountId',
  'loadingStripeAccountIdFailed',
  'excludedFromSelfSignup',
  'redirectToConsultation',
]);

export const InsuranceV4LoadingStep = withInsuranceMachineStateV4(Loading, [
  'skippedPrimaryPhysician',
  'checkEligibilityInformation',
  'checkEligibilityInformationError',
  'loadingMedicaidProviderList',
  'loadingMedicaidProviderListError',
]);
